import { sendGeneralEmail } from "../api/tenantApi";

// Where prospect sign-up / trial alerts are sent. Change this to your team inbox
// (e.g. sales@crediarc.com) — it's just a recipient, not a secret.
export const TEAM_NOTIFY_EMAIL = "info@crediarc.com";

/**
 * Fire-and-forget internal notification to the team. Never throws — a failed
 * alert must not break the user's flow.
 */
export const notifyTeam = async ({ subject, message }) => {
  try {
    await sendGeneralEmail({ to: TEAM_NOTIFY_EMAIL, subject, message });
  } catch (e) {
    console.warn("Team notification failed:", e?.message);
  }
};

// Build a readable body from a set of label/value lines.
export const formatLines = (obj) =>
  Object.entries(obj || {})
    .filter(([, v]) => v != null && v !== "")
    .map(([k, v]) => `${k}: ${v}`)
    .join("\n");
